import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { authGuard } from './services/account/auth.guard';

const routes: Routes = [
  {
    path: '',
    loadChildren: () =>
      import('./components/home/home.module').then((m) => m.HomeModule),
    canActivate: [authGuard],
    data: { component: 'home' },
  },
  { path: 'home', redirectTo: '', pathMatch: 'full' },


  {
    path: 'stock',
    loadChildren: () =>
      import('./components/stock/stock.module').then((m) => m.StockModule),
  },

  {
    path: 'sales',
    loadChildren: () =>
      import('./components/sales/sales.module').then((m) => m.SalesModule)
  },


  {
    path: 'finance',
    loadChildren: () =>
      import('./components/finance/finance.module').then((m) => m.FinanceModule),
    canActivate: [authGuard],
    data: { component: 'finance' },
  },


  {
    path: 'utilisateur',
    loadChildren: () =>
      import('./components/utilisateur/utilisateur.module').then(
        (m) => m.UtilisateurModule
      ),
    canActivate: [authGuard],
    data: { component: 'utilisateur' },
  },

  {
    path: 'config',
    loadChildren: () =>
      import('./components/config/config.module').then((m) => m.ConfigModule),
    canActivate: [authGuard],
    data: { component: 'config' },
  },

  {
    path: 'dashboard',
    loadChildren: () =>
      import('./components/dashboard/dashboard.module').then((m) => m.DashboardModule),
    canActivate: [authGuard],
    data: { component: 'dashboard' },
  },

  {
    path: 'account',
    loadChildren: () =>
      import('./components/account/account.module').then(
        (m) => m.AccountModule
      ),
  },
  {
    path: '**',
    loadChildren: () =>
      import('./components/not-found/not-found.module').then(
        (m) => m.NotFoundModule
      ),
  },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      onSameUrlNavigation: 'reload',
      scrollPositionRestoration: 'top',
    }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule { }
